import en from './feeBasedInstantTransferStrings.en';

export default {
  en,
};
